export default "__VITE_ASSET__CPBk9tfk__"